import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IO365VisioUsage,
  ISearchO365VisioUsage,
} from '../../../services/o365/o365VisioUsage/o365VisioUsage.model';
import o365VisioUsageService from '../../../services/o365/o365VisioUsage/o365VisioUsage.service';

export const searchO365VisioUsage = createAsyncThunk(
  'searchO365VisioUsage',
  async (searchParam?: ISearchO365VisioUsage) => {
    const response = await o365VisioUsageService.searchO365VisioUsage(searchParam).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const getO365VisioUsageById = createAsyncThunk(
  'getO365VisioUsageById',
  async (id: number) => {
    const response = await o365VisioUsageService.getO365VisioUsageById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveO365VisioUsage = createAsyncThunk(
  'saveO365VisioUsage',
  async (data: IO365VisioUsage) => {
    const response = await o365VisioUsageService.saveO365VisioUsage(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteO365VisioUsage = createAsyncThunk(
  'deleteO365VisioUsage',
  async (id: number) => {
    const response = await o365VisioUsageService.deleteO365VisioUsage(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
